"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Stats_1 = require("./_Stats");
exports._StatsEvent = {
    type: "structure",
    required: [],
    members: {
        Details: {
            shape: _Stats_1._Stats
        }
    }
};
//# sourceMappingURL=_StatsEvent.js.map